import appStorage from "@/lib/appStorage";

export function getReferral() {
  return appStorage.getString("referralId", "0");
}

export function setReferral(referral: string) {
  if (getReferral() === "0" && referral.length > 0) {
    appStorage.setString("referralId", referral);
  }
}
